import BaseModel from 'models/base-model';
import { SocketClient, SOCKET_CONNECTION_TYPE } from 'socket/socketio-client';
import { SignalrClient } from 'socket/signalr-client';
import { statementWorkflowsLoaded } from 'store/actions/statement-workflows-actions';
import { NOTIFICATION_EVENT_TYPES } from 'constants/web-socket-constants';
import {
  onCopyStatementSuccess,
  onCopyStatementFailure,
  _isCopyErrorForWrongSourceProject,
  copyErrorNotificationForWrongSourceProject,
} from 'store/actions/statement-list/statement-list-actions';
import {
  getWebSocketNotificationType,
  getWebSocketPayload,
} from 'constants/util/web-socket-utils';
import { isSignalRForSocketConnectionEnabled } from 'api/api-constants';
import { toast } from 'react-toastify';
import { updateProjectSocketClient } from 'store/actions/project-socket-actions';

export default class ProjectSocketModel extends BaseModel({
  client: null,
  socketHasBeenDisconnected: true,
}) {
  init(config) {
    if (isSignalRForSocketConnectionEnabled) {
      const client = new SignalrClient({
        ...config,
        isProjectLevelConnection: true,
      });
      return this.merge({ ...this, client, socketHasBeenDisconnected: false });
    } else {
      const client = new SocketClient({
        ...config,
        socketConnectionType: SOCKET_CONNECTION_TYPE.PROJECT,
      });
      return this.merge({ ...this, client, socketHasBeenDisconnected: false });
    }
  }

  setProjectSocketClients(dispatch) {
    if (this.client) {
      this.client.on('newMessage', (event) =>
        this.onEventHandler(event, dispatch),
      );
    }
    return this;
  }

  stopProjectSocketConnection() {
    //if application connected to signalr
    if (
      isSignalRForSocketConnectionEnabled &&
      this.client &&
      this.client.connection
    ) {
      this.client.connection.stop();
    }
    //if application connected to socketio
    if (!isSignalRForSocketConnectionEnabled && this.client) {
      this.client._closeSocketConnection();
      this.client.disconnect();
      return this.merge({ ...this, socketHasBeenDisconnected: true });
    }
    return this;
  }

  setProjectSocketDisconnect(payload) {
    return this.merge({ ...this, socketHasBeenDisconnected: payload });
  }

  onEventHandler = async (event, dispatch) => {
    const webSocketPayload = getWebSocketPayload(event);
    const response = {
      data: webSocketPayload && webSocketPayload.documentProcessWorkflowEntity,
    };
    switch (getWebSocketNotificationType(event)) {
      case NOTIFICATION_EVENT_TYPES.WORKFLOW_STATUS:
        await dispatch(statementWorkflowsLoaded({ response }));
        await dispatch(updateProjectSocketClient({ webSocketPayload }));
        break;
      case NOTIFICATION_EVENT_TYPES.STATEMENT_COPY_SUCCESSFUL:
        await dispatch(onCopyStatementSuccess());
        break;
      case NOTIFICATION_EVENT_TYPES.STATEMENT_COPY_FAILED:
        if (_isCopyErrorForWrongSourceProject(webSocketPayload)) {
          toast.error(copyErrorNotificationForWrongSourceProject());
          return;
        }
        await dispatch(onCopyStatementFailure());
        break;
      default:
        break;
    }
  };
}
